<template>
  <v-card>
    <v-card-title>
      <v-btn icon text @click="getItems">
        <v-icon>refresh</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-select v-model="selectedFilter" :items="cellFilters" filled outlined hide-details dense rounded class="mr-2"
        multiple style="max-width: 340px"></v-select>
      <v-text-field v-model="search" append-icon="search" label="Search" single-line hide-details clearable dense filled
        outlined rounded></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="list" :loading="loading" :server-items-length="totalItems"
      :options.sync="options">
      <template v-slot:top>
        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>

            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.id" label="Cell #" :readonly="true"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.value" label="Value"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.power" label="Power"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="3">
                    <v-text-field v-model="editedItem.pov" label="Power / Value" :readonly="true"></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
              <v-btn color="blue darken-1" text @click="save" :loading="updating">Save</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </template>
      <template v-slot:item.action="{ item }">
        <v-btn icon text @click="editItem(item)" class="mr-1">
          <v-icon small>edit</v-icon>
        </v-btn>
        <v-btn icon text @click="deleteItem(item)" color="red">
          <v-icon small>delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import api from "@/api";
// import { debounce } from "lodash";
export default {
  name: "AllCells",
  data: () => ({
    totalItems: 0,
    dialog: false,
    loading: false,
    options: {},
    headers: [
      {
        text: 'Cell #',
        align: 'left',
        sortable: false,
        value: 'number',
      },
      { text: 'Value', value: 'value' },
      { text: 'Power', value: 'power' },
      { text: 'Power / Value', value: 'pov' },
      { text: 'Actions', value: 'action', sortable: false },
    ],
    list: [],
    editedItem: {
      id: '',
      power: 0,
      value: 0,
      pov: 0,
    },
    updating: false,
    defaultItem: {
      id: '',
      power: 0,
      value: 0,
      pov: 0,
    },
    search: '',
    editedIndex: -1,
    formTitle: "Edit Cell",
    cellFilters: [
      {
        text: "Balanced",
        value: "balanced"
      },
      {
        text: "Number",
        value: "number"
      },
      {
        text: "Value",
        value: "value"
      },
      {
        text: "Power",
        value: "power"
      },
      {
        text: "Charge",
        value: "charge"
      }
    ],
    selectedFilter: ['number']
  }),


  watch: {
    dialog(val) {
      val || this.close()
    },
    options: {
      handler() {
        this.getItems()
      },
      deep: true,
    },
    search() {
      this.getItems()
    }
  },
  methods: {
    initialize() {
      this.getItems()
    },

    async getItems() {
      const { page = 0, itemsPerPage = 10 } = this.options
      this.loading = true;
      // const response = await api.getAllCellsList(itemsPerPage, page, this.search);
      const response = await api.getCellsList(itemsPerPage, page, this.search, this.selectedFilter);
      this.totalItems = response.data.count;
      this.list = response.data.data;
      this.loading = false;
    },

    editItem(item) {
      this.editedItem = Object.assign({}, item)
      this.editedIndex = this.list.indexOf(item)
      this.dialog = true
    },

    async deleteItem(item) {
      const confirm = await this.$alert.confirm();
      if (confirm && confirm.value === true) {
        try {
          await api.deleteCells([item.number]);
          this.getItems()
          this.$toast.success({ title: "Deleted Successfully" })
        } catch (error) {
          this.$toast.error({ title: "Error Deleting" })
        }
      }
    },

    close() {
      this.dialog = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300)
    },

    async save() {
      if (this.editedIndex > -1) {
        try {
          this.updating = true;
          await api.updateCell(this.editedItem)
          Object.assign(this.list[this.editedIndex], this.editedItem)
          this.editedIndex = -1;
          this.$toast.success({ title: "Cell Updated Successfully" });
        } catch (error) {
          this.$toast.error({ title: "Error Updating" });
        }
        this.updating = false;
      }
      this.close()
    },
  },
  mounted() {

  }
};
</script>